import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.favoritesLimitModal';

export default defineMessages({
  okButton: {
    id: `${scope}.okButton`,
    defaultMessage: 'OK',
  },
  modalBodyHeader: {
    id: `${scope}.modalBodyHeader`,
    defaultMessage: 'Favorites limit reached',
  },
  modalBodyDescription: {
    id: `${scope}.modalBodyDescription`,
    defaultMessage: 'You can add up to {limit} courses and lessons to favorites. To add this content, please unfavorite another course or lesson.',
  },
});
